export default import.meta.ROLLDOWN_FILE_URL_6jJsJFqALfPLhO5QJBlJcw